import {useCallback} from "react";
import {EBirdMyDataSchema} from "ebird-mydata-reader";
import {EBirdMyDataSchemaWithImage} from "../views/big-year";
import {EBirdTaxonomyEntry} from "./useEBirdTaxonomy";

export function useObservationImages(
    speciesImages: any,
    lookupByTaxonomicOrder: (taxonomicOrder: number) => EBirdTaxonomyEntry|undefined
) {
    const setObservationImages = useCallback((observations: EBirdMyDataSchema[]): EBirdMyDataSchemaWithImage[] => {
        for (let observation of observations as EBirdMyDataSchemaWithImage[]) {
            if (Object.prototype.hasOwnProperty.call(speciesImages, observation.taxonomicOrder)) {
                observation.image = speciesImages[observation.taxonomicOrder].medium;
            }

            const taxonomicData = lookupByTaxonomicOrder(observation.taxonomicOrder);
            if (taxonomicData) {
                observation.speciesGroup = taxonomicData.speciesGroup;
            }
        }

        return observations as EBirdMyDataSchemaWithImage[];
    }, [lookupByTaxonomicOrder, speciesImages]);

    const setObservationImagesForMarkers = useCallback((markers: any) => {
        for (let marker of markers.features) {
            if (Object.prototype.hasOwnProperty.call(speciesImages, marker.properties.taxonomicOrder)) {
                marker.properties.image = speciesImages[marker.properties.taxonomicOrder].thumb;
            }
        }
    }, [speciesImages]);

    return {
        setObservationImages,
        setObservationImagesForMarkers
    }
}
